<template>
    <div class="box" ref="box">
        <p class="page-title" v-if="pageTitle">{{pageTitle}}</p>
        <div class="search" >
            <template v-if="searchConfig.length > 0">
              <template  v-for="search in searchConfig">
                  <span class="inputBox" v-if="search.type === 'input'"  :key="search.key">
                      <span class="tabel">{{search.title}}</span>
                      <el-input v-model="search.value" :placeholder="`请输入${search.title}`"></el-input>
                  </span>
                  <span class="inputBox" v-if="search.type === 'select'" :key="search.key">
                      <span class="tabel">{{search.title}}</span>
                      <el-select v-model="search.value" clearable filterable :placeholder="`请选择${search.title}`">
                          <el-option
                              v-for="item in search.list"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                      </el-select>
                  </span>
                  <span class="inputBox" v-if="search.type === 'date'" :key="search.key">
                      <span class="tabel">{{search.title}}</span>
                      <el-date-picker
                          v-model="search.value"
                          value-format="yyyy-MM-dd"
                          type="date"
                          :placeholder="`请选择${search.title}`">
                      </el-date-picker>
                  </span>
                  <span class="inputBox" v-if="search.type === 'date2'" :key="search.key">
                      <span class="tabel">{{search.title}}</span>
                      <el-date-picker
                          v-model="search.value"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                      </el-date-picker>
                  </span>
                  <span class="inputBox" v-if="search.type === 'date4'" :key="search.key">
                      <span class="tabel">{{search.title}}</span>
                      <el-date-picker
                          v-model="search.value"
                          type="monthrange"
                          value-format="yyyy-MM"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                      </el-date-picker>
                  </span>
                  <span class="inputBox" v-if="search.type === 'date3'" :key="search.key">
                      <span class="tabel">{{search.title}}</span>
                      <el-date-picker
                          v-model="search.value"
                          type="month"
                          value-format="yyyy-MM"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                      </el-date-picker>
                  </span>
              </template>
              <el-button class="btn" @click="handleBtn('search')">查 询</el-button>
            </template>
          <div class="rightBtns" ref="right">
            <template v-for="btn in btnConfig">
              <el-button @click="handleBtn(btn.key, btn)" :style="{background: btn.bg}" class="btn"  :key="btn.key">{{btn.title}}</el-button>
            </template>
          </div>
        </div>
    </div>
</template>

<script>
    import { export_json_to_excel } from '@/utils/Export2Excel'
    export default {
        data() {
            return {
                rightWidth: 0
            }
        },
        props: {
            searchConfig: {
                type: Array,
                default() {
                    return []
                }
            },
            btnConfig: {
                type: Array,
                default() {
                    return []
                }
            },
            pageTitle: {
                type: String,
                default: ''
            }
        },
        computed: {
            getExportList() {
                return (btn) => {
                    if (btn.data.length > 0) {
                        return btn.data
                    } else {
                        return btn.defaultList
                    }   
                }
            }
        },
        mounted() {
            // this.compWidth();
            // window.addEventListener('resize',  () => this.compWidth())
        },
        methods: {
            // compWidth() {
            //     const box = this.$refs.box.clientWidth;
            //     const right = this.$refs.right.clientWidth;
            //     this.rightWidth = box * 0.81 + right > box ? box - right : box * 0.81;
            // },
            handleBtn(key, btn) {
                this.$emit('handleBtn', key, btn)
            },
        }
    }
</script>

<style lang="less" scoped>
    /deep/ span{
        vertical-align: middle;
    }
    .page-title{
        font-size: 16px;
        color: #666666;
        margin-bottom: 8px;
    }
    .search{
        background: #FFFFFF;
        line-height: 55px;
        padding: 0 20px 0 16px;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
    }
    .box{
        min-height: 55px;
        position: relative;
    }
    .el-input, .el-select{
        width: 150px;
    }
    /deep/ .el-input__inner{
        height: 27px;
    }
    .tabel{
        margin-right: 18px;
        font-size: 16px;
        display: inline-block;
        //width: 70px;
    }
    .inputBox{
        display: inline-block;
        margin-right: 61px;
    }
    .inputBox:last-child{
        margin-right: 0;
    }
    .btn{
        padding: 0 17px;
        min-width: 78px;
        box-sizing: border-box;
        height: 30px;
        background: #EA5B24;
        border-radius: 4px;
        font-size: 16px;
        color: #FFFFFF;
    }
    .rightBtns{
      text-align: right;
    }
    /deep/ .el-input__icon{
        height: auto;
    }
    /deep/ .el-range-separator{
        line-height: 19px;
    }
    /deep/ .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
        width: 300px;
    }
</style>